import { useCallback } from 'react'
import { useIntl } from 'react-intl'

import { useGetExperiment } from '../../experiments/hooks'
import { EXPERIMENT_NAME_FULLSTORY_TRACKING } from '../../experiments/model/EXPERIMENT_NAME'
import { EXPERIMENT_VARIATION } from '../../experiments/model/EXPERIMENT_VARIATION'
import { useUserApiSwrSessionV1Customer } from '../../user-data'
import {
  directContactFormSubmitFullStoryTracking,
  getContactFormLaunchOriginValues,
} from '../gtm/fullstory-events-tracking/directContactFormSubmitFullStoryTracking'
import { directContactFormAccessorGetSubjects } from '../model/directContactFormAccessorGetSubjects'

export const useDirectContactFormSubmitFullStoryTracking = ({
  contactFormLaunchOrigin,
  formSubject,
}: {
  contactFormLaunchOrigin?: string
  formSubject?: string
}): (() => void) => {
  const intl = useIntl()
  const { data: userData } = useUserApiSwrSessionV1Customer()
  const isFullStoryTrackingEnabled =
    useGetExperiment(EXPERIMENT_NAME_FULLSTORY_TRACKING).variant ===
    EXPERIMENT_VARIATION.V1
  const isOrderTypeSubject = directContactFormAccessorGetSubjects({
    intl,
    option: formSubject,
  }).orderType
  const contactFormLaunchOriginValue = getContactFormLaunchOriginValues(
    Boolean(userData?.customerNumber),
    isOrderTypeSubject,
    contactFormLaunchOrigin,
  )

  return useCallback((): void => {
    if (contactFormLaunchOriginValue && isFullStoryTrackingEnabled) {
      directContactFormSubmitFullStoryTracking({
        contactFormLaunchOriginValue,
      })
    }
  }, [contactFormLaunchOriginValue, isFullStoryTrackingEnabled])
}
